import axios from 'axios';

import TakeCustomerPresentCardPaymentError from 'errors/TakeCustomerPresentCardPaymentError';

const takeCustomerPresentCardPayment = async (_, { amount, sender }) => {
  const {
    data,
    data: { OverallResult, CardResponse, printerReceipt }
  } = await axios({
    method: 'POST',
    url: 'http://localhost:8000/start',
    data: { amount, sender },
    headers: { 'Content-Type': 'text/plain' }
  });

  if (OverallResult !== 'Success') {
    throw new TakeCustomerPresentCardPaymentError({ data });
  }

  CardResponse.printerReceipt = printerReceipt;

  return CardResponse;
};

export default takeCustomerPresentCardPayment;
